var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaCard4Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343 629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 629,
    style: {
      fill: "#2a38f8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 124,
    x2: 100,
    y2: 165,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 124,
    x2: 245,
    y2: 165,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 146,
    r: 6,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 146,
    r: 6,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 146,
    r: 6,
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,152.4l3.66-14.4h6.1c2.86,0,4.68,1.81,4.68,4.18,0,2.22-1.57,4.07-3.97,4.86l1.57,5.37h-4.18l-1.27-4.98h-1.38l-1.27,4.98h-3.94ZM271.97,144.37h2.3c1.25,0,2.15-.93,2.15-2,0-.78-.54-1.3-1.28-1.3h-2.34l-.84,3.29h.01Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.93,152.4l2.82-11.11h-3.86l.84-3.29h11.7l-.84,3.29h-3.86l-2.82,11.11h-3.98Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,152.4l3.64-14.4h3.8l3.11,8.44,2.03-8.44h3.86l-3.64,14.4h-3.8l-3.13-8.44-1.98,8.44h-3.89,0Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 309,
    height: 595,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 124,
    x2: 327,
    y2: 124,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 166,
    x2: 327,
    y2: 166,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 366,
    x2: 327,
    y2: 366,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 506,
    x2: 327,
    y2: 506,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,491.82c-61.21,0-111-24.49-111-54.59s49.8-54.59,111-54.59h1.13c.36,0,.73,0,1.09.01,60.17.58,108.78,24.84,108.78,54.58s-48.59,53.99-108.78,54.58c-.36,0-.72.01-1.09.01h-1.13ZM145.62,485.92c-47.35-5.02-82.82-24.94-82.82-48.69s35.47-43.67,82.82-48.69c-17.62,9.03-29.72,27.46-29.72,48.69s12.1,39.66,29.72,48.69ZM195.29,485.59c45.89-5.51,79.92-25.1,79.92-48.36s-34.03-42.85-79.92-48.36c17.28,9.14,29.09,27.39,29.09,48.36s-11.81,39.22-29.09,48.36ZM155.68,389.28c-10.22,3.12-19.06,9.46-25.35,17.83,3.14,2.14,6.83,3.92,10.91,5.37,1.17-3.93,2.62-7.57,4.33-10.84,2.81-5.35,6.21-9.49,10.11-12.36ZM167.87,389.05c-10.88,1.21-18.42,11.43-22.39,24.77,6.9,1.93,14.61,2.98,22.39,3.15v-27.92h0ZM140.13,416.67c-4.67-1.61-8.83-3.61-12.27-5.94-4.5,7.23-7.22,15.69-7.53,24.75h17.5c.14-6.6.93-12.96,2.31-18.81h0ZM142.21,435.48c.14-5.98.87-11.94,2.16-17.49,7.09,1.97,15.12,3.12,23.49,3.29v14.2h-25.66,0ZM137.82,439.86h-17.46c.47,8.99,3.3,17.36,7.89,24.5,3.45-2.29,7.46-4.19,11.86-5.73-1.37-5.84-2.15-12.18-2.29-18.77h0ZM144.36,457.3c-1.29-5.54-2.01-11.48-2.15-17.44h25.66v14.13c-8.15.17-16.23,1.27-23.51,3.32h0ZM141.24,462.88c-3.89,1.37-7.43,3.05-10.46,5.05,5.86,7.57,13.83,13.41,23.01,16.62-3.12-2.74-5.88-6.37-8.23-10.84-1.71-3.26-3.16-6.9-4.33-10.83h.01ZM167.87,486.3c-10.88-1.21-18.41-11.42-22.39-24.76,6.89-1.92,14.6-2.97,22.39-3.14v27.89h0ZM194.57,401.64c-2.83-5.39-6.26-9.56-10.2-12.42,10.29,3.08,19.21,9.42,25.54,17.83-3.15,2.16-6.89,3.98-11.01,5.43-1.17-3.93-2.62-7.57-4.33-10.84h0ZM172.26,389.05c10.89,1.21,18.42,11.43,22.4,24.77-6.9,1.93-14.61,2.99-22.4,3.15v-27.92h0ZM197.92,435.48c-.14-5.99-.87-11.95-2.17-17.5-7.09,1.97-15.11,3.12-23.5,3.29v14.21h25.67ZM200,416.66c1.38,5.85,2.17,12.21,2.31,18.82h17.65c-.31-9.1-3.05-17.58-7.58-24.83-3.47,2.36-7.66,4.38-12.38,6.01h0ZM172.26,439.86h25.67c-.14,6.14-.85,12.03-2.1,17.45-7.29-2.05-15.4-3.16-23.57-3.33v-14.13h0ZM202.31,439.86c-.14,6.59-.93,12.93-2.29,18.77,4.44,1.55,8.5,3.48,11.97,5.8,4.62-7.15,7.47-15.54,7.94-24.57h-17.62ZM172.26,458.41c7.81.16,15.54,1.22,22.45,3.15-1.09,3.68-2.44,7.08-4.03,10.12-3.28,6.25-9.07,13.62-18.42,14.62v-27.9h0ZM194.57,473.71c-2.37,4.52-5.16,8.17-8.32,10.93,9.26-3.18,17.3-9.04,23.21-16.64-3.06-2.03-6.63-3.73-10.56-5.12-1.17,3.93-2.62,7.57-4.32,10.83h0Z",
    style: {
      fill: "#0e0e0e",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(47.25 151.46)",
    style: {
      fontFamily: "StabilGrotesk-BlackItalic, &apos",
      fontSize: 19,
      fontStyle: "italic",
      fontWeight: 800,
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "04")))), /*#__PURE__*/React.createElement("path", {
    d: "M56.07,99.8c-17.27,0-29.88-13.12-29.88-31.32s12.61-31.32,29.88-31.32,29.97,13.12,29.97,31.32-12.7,31.32-29.97,31.32ZM34.65,68.48c0,13.8,9.06,23.87,21.42,23.87s21.42-10.07,21.42-23.87-8.97-23.96-21.42-23.96-21.42,10.07-21.42,23.96ZM95.47,98.11v-59.26h23.03c11.94,0,20.32,8.04,20.32,18.79s-8.38,18.88-20.32,18.88h-14.65v21.59h-8.38ZM103.85,69.83h13.88c7.37,0,12.53-5.08,12.53-12.19s-5.16-12.11-12.53-12.11h-13.88v24.3ZM147.2,98.11v-59.26h23.03c11.94,0,20.32,8.04,20.32,18.79s-8.38,18.88-20.32,18.88h-14.65v21.59h-8.38,0ZM155.58,69.83h13.88c7.37,0,12.53-5.08,12.53-12.19s-5.16-12.11-12.53-12.11h-13.88v24.3ZM227.88,99.8c-17.27,0-29.88-13.12-29.88-31.32s12.61-31.32,29.88-31.32,29.97,13.12,29.97,31.32-12.7,31.32-29.97,31.32ZM206.46,68.48c0,13.8,9.06,23.87,21.42,23.87s21.42-10.07,21.42-23.87-8.97-23.96-21.42-23.96-21.42,10.07-21.42,23.96ZM267.28,98.11v-59.26h23.62c11.68,0,20.06,7.45,20.06,17.78,0,8.47-5.42,14.9-13.55,17.1l14.39,24.38h-9.48l-13.38-23.53h-13.38v23.53h-8.3.02ZM275.58,67.97h14.9c6.94,0,11.94-4.74,11.94-11.26s-4.99-11.17-11.94-11.17h-14.9v22.43Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.76,591.53v-1.37l5.23-.34,2.06-1.11,14.06-56.82-9.6-.69-8.74,15.94h-1.71l5.57-17.91h1.46l3.86.6h23.74l4.2-.6h1.46l-.6,17.91h-1.54l-3.09-15.86-9.17.51-13.97,56.91,2.06,1.11,5.14.34v1.37h-20.42ZM81.03,592.82c-9.34,0-15.43-6.94-10.88-25.03l8.83-35.14-1.71-1.11-4.11-.34v-1.37h19.37v1.37l-5.49.34-2.14,1.11-9.17,36.17c-3.77,15.08.77,20.4,7.46,20.4s12-5.31,15.51-19.8l9.17-36.77-1.89-1.11-4.89-.34v-1.37h15.51v1.37l-4.37.34-1.71,1.11-9,36.08c-4.46,17.91-11.66,24.08-20.48,24.08h-.01ZM136.57,591.53l-10.2-55.54-12.86,52.71,2.23,1.11,5.4.34v1.37h-16.03v-1.37l4.2-.34,1.63-1.11,14.14-56.57-5.49-1.11v-1.2h11.66l10.11,55.88,13.03-53.05-2.14-1.11-5.4-.34v-1.37h16.03v1.37l-4.2.34-1.63,1.11-14.74,58.88h-5.74ZM152.47,591.53v-1.37l4.46-.34,1.8-1.11,14.06-56.05-1.71-1.11-4.37-.34v-1.37h18.26v1.37l-4.54.34-1.71,1.11-14.06,56.05,1.71,1.11,4.37.34v1.37h-18.27ZM183.02,591.53v-1.37l5.23-.34,2.06-1.11,14.06-56.82-9.6-.69-8.74,15.94h-1.71l5.57-17.91h1.46l3.86.6h23.74l4.2-.6h1.46l-.6,17.91h-1.54l-3.09-15.86-9.17.51-13.97,56.91,2.06,1.11,5.14.34v1.37h-20.42ZM215.37,591.53v-1.37l4.46-.34,1.8-1.11,14.06-56.05-1.71-1.11-4.37-.34v-1.37h18.26v1.37l-4.54.34-1.71,1.11-14.06,56.05,1.71,1.11,4.37.34v1.37h-18.27ZM238.79,591.53v-1.37l4.2-.34,1.63-1.11,14.06-56.05-1.63-1.11-4.11-.34v-1.37h30.43v15.51h-1.63l-3.77-13.37h-13.28l-6.6,26.57h7.03l8.66-1.2h1.54v4.8h-1.54l-8.66-1.29h-7.63l-7.11,28.54h15.17l9.26-14.91h1.54l-5.49,17.06h-32.05l-.02-.02ZM292.88,592.73c-5.66,0-10.28-2.4-13.63-6.34l1.8-14.14h1.8l.43,5.23c1.03,10.03,5.74,13.2,10.46,13.2,6.94,0,12-6.17,12-13.8,0-4.37-1.63-7.97-4.97-11.83l-5.91-6c-3.6-4.03-5.74-7.71-5.74-13.03,0-9.86,7.71-17.4,17.4-17.4,4.8,0,8.91,1.97,12.43,5.66l-1.71,13.54h-1.71l-.43-4.97c-.86-8.31-4.29-12.34-9.6-12.34-6.17,0-10.71,5.14-10.71,12.43,0,4.71,1.89,8.31,5.06,11.91l6,6.26c3.69,4.11,5.66,7.46,5.66,12.51,0,10.8-7.97,19.11-18.6,19.11h-.03Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.35,210.82c0-4.29,2.97-7.38,7.05-7.38s7.07,3.09,7.07,7.38-2.99,7.38-7.07,7.38-7.05-3.09-7.05-7.38ZM55.39,216.45c2.93,0,5.05-2.38,5.05-5.63s-2.12-5.65-5.05-5.65-5.05,2.38-5.05,5.65,2.14,5.63,5.05,5.63Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,207.85h1.9v1.68c.74-1.24,1.98-1.94,3.51-1.94,2.67,0,4.61,2.18,4.61,5.25s-1.94,5.23-4.61,5.23c-1.54,0-2.77-.7-3.51-1.94v5.47h-1.9v-13.75ZM69.46,216.51c1.84,0,3.17-1.54,3.17-3.67s-1.34-3.69-3.17-3.69-3.15,1.5-3.15,3.69,1.3,3.67,3.15,3.67Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.45,207.85h1.9v1.68c.74-1.24,1.98-1.94,3.51-1.94,2.67,0,4.61,2.18,4.61,5.25s-1.94,5.23-4.61,5.23c-1.54,0-2.77-.7-3.51-1.94v5.47h-1.9v-13.75ZM81.38,216.51c1.84,0,3.17-1.54,3.17-3.67s-1.34-3.69-3.17-3.69-3.15,1.5-3.15,3.69,1.3,3.67,3.15,3.67Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,212.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.1,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM92.99,216.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,207.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.44,214.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74,216.53c1.64,0,2.55-1.26,2.55-3.53v-5.15h1.9v9.96h-1.9l.06-1.94c-.52,1.4-1.64,2.2-3.25,2.2-2.14,0-3.51-1.54-3.51-4.01v-6.21h1.88v5.85c0,1.82.82,2.83,2.28,2.83Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.36,207.85h1.9l-.06,2.43c.42-1.7,1.56-2.69,3.31-2.69,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.34-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.16,203.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36ZM136.2,207.85h1.9v9.96h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.53,214.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,203.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36ZM147.75,207.85h1.9v9.96h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.46,212.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.53-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM159.37,211.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,214.66l1.76-.06c.12,1.36,1.18,2.21,2.63,2.21,1.18,0,2.2-.54,2.2-1.58,0-.78-.6-1.22-1.78-1.46l-1.7-.32c-1.94-.32-2.83-1.36-2.83-2.81,0-1.94,1.62-3.15,3.83-3.15s3.97,1.4,4.07,3.47l-1.7.1c-.08-1.3-1.06-2.21-2.4-2.21-1.12,0-2.02.62-2.02,1.62,0,.74.5,1.2,1.4,1.36l1.7.32c2.1.38,3.23,1.34,3.23,2.91,0,1.92-1.72,3.09-4.01,3.09-2.5,0-4.23-1.36-4.39-3.49Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.95,214.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48,212.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.09,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM188.54,216.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,207.85h2.04l2.51,7.84,2.4-7.84h2.1l2.42,7.84,2.51-7.84h2l-3.41,9.96h-2.12l-2.44-7.9-2.46,7.9h-2.13l-3.41-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.21,212.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.09,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM220.28,216.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,207.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.27,203.84h1.88v8.5l4.89-4.49h2.25l-4.05,3.73,4.15,6.23h-2.12l-3.31-5.05-1.82,1.66v3.39h-1.88v-13.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.72,238.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.25,236.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.1,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM60.32,240.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21,242.09l1.86-.08c.2,1.42,1.42,2.38,3.09,2.38,1.86,0,3.07-1.2,3.07-3.15v-1.92c-.56,1.26-1.94,2.2-3.55,2.2-2.67,0-4.79-2.12-4.79-4.99s2.08-4.97,4.79-4.97c1.62,0,3.07.9,3.63,2.26v-1.96h1.8v9.08c0,3.11-1.92,4.97-4.95,4.97-2.79,0-4.75-1.54-4.95-3.81ZM72.08,239.95c1.84,0,3.27-1.44,3.27-3.43s-1.36-3.41-3.27-3.41-3.29,1.5-3.29,3.41,1.44,3.43,3.29,3.43Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.92,236.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.54-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM86.82,235.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.58,238.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8,227.84h1.9v6.23c.46-1.56,1.58-2.47,3.25-2.47,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.34-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-13.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28,236.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.54-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM116.18,235.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.89,231.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.49,236.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.1,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM135.56,240.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.42,231.85h1.9l-.06,2.43c.42-1.7,1.56-2.69,3.31-2.69,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.34-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,231.85h1.9l-.06,2.43c.42-1.7,1.56-2.69,3.31-2.69,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.34-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,236.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.09,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM172.64,240.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,231.85h1.9l-.06,2.43c.42-1.7,1.56-2.69,3.31-2.69,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.33-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,235.44h5.73v1.56h-5.73v-1.56Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.72,236.82c0-3.03,2.16-5.27,5.09-5.27,2.53,0,4.57,1.64,4.73,3.99l-1.86.16c-.16-1.46-1.38-2.51-2.89-2.51-1.84,0-3.17,1.54-3.17,3.63,0,2.35,1.52,3.61,3.17,3.61,1.44,0,2.73-.96,2.91-2.58l1.86.14c-.14,2.44-2.18,4.11-4.75,4.11-2.95,0-5.09-2.22-5.09-5.29Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9,236.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.09,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM213.97,240.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.83,231.85h1.9l-.06,2.47c.4-1.72,1.54-2.73,3.31-2.73s2.91.98,3.35,2.61c.42-1.66,1.6-2.61,3.35-2.61,2.14,0,3.49,1.54,3.49,3.99v6.23h-1.9v-5.85c0-1.82-.8-2.83-2.24-2.83-1.62,0-2.54,1.26-2.54,3.53v5.15h-1.88v-5.85c0-1.82-.84-2.83-2.32-2.83-1.68,0-2.59,1.26-2.59,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,231.85h1.9l-.06,2.47c.4-1.72,1.54-2.73,3.31-2.73s2.91.98,3.35,2.61c.42-1.66,1.6-2.61,3.35-2.61,2.14,0,3.49,1.54,3.49,3.99v6.23h-1.9v-5.85c0-1.82-.8-2.83-2.24-2.83-1.62,0-2.54,1.26-2.54,3.53v5.15h-1.88v-5.85c0-1.82-.84-2.83-2.32-2.83-1.68,0-2.59,1.26-2.59,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.36,236.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.54-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM263.26,235.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.97,231.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,236.82c0-3.03,2.16-5.27,5.09-5.27,2.54,0,4.57,1.64,4.73,3.99l-1.86.16c-.16-1.46-1.38-2.51-2.89-2.51-1.84,0-3.17,1.54-3.17,3.63,0,2.35,1.52,3.61,3.17,3.61,1.44,0,2.73-.96,2.91-2.58l1.86.14c-.14,2.44-2.17,4.11-4.75,4.11-2.95,0-5.09-2.22-5.09-5.29Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,227.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36ZM284.84,231.85h1.9v9.96h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.45,239.26c0-1.86,1.6-2.85,4.61-3.19l2.04-.22v-.4c0-1.46-.82-2.38-2.22-2.38-1.28,0-2.18.82-2.29,2.2l-1.84-.06c.16-2.17,1.84-3.65,4.19-3.65s4.01,1.56,4.01,3.95v3.45c0,1.08.12,2.16.26,2.85h-1.84c-.12-.46-.2-1.02-.2-2.06-.46,1.38-1.82,2.28-3.49,2.28-1.88,0-3.23-1.04-3.23-2.77ZM292.26,240.71c1.6,0,2.85-1.22,2.85-2.97v-.76l-1.92.24c-1.86.22-2.85.72-2.85,1.88s.84,1.62,1.92,1.62Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.03,239.04v-11.2h1.88v10.84c0,1.46.8,1.8,2,1.42l.04,1.58c-1.88.54-3.91.22-3.91-2.63Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.07,260.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.1,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM53.14,264.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,255.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,263.26c0-1.86,1.6-2.85,4.61-3.19l2.04-.22v-.4c0-1.46-.82-2.38-2.22-2.38-1.28,0-2.18.82-2.3,2.2l-1.84-.06c.16-2.17,1.84-3.65,4.19-3.65s4.01,1.56,4.01,3.95v3.45c0,1.08.12,2.16.26,2.85h-1.84c-.12-.46-.2-1.02-.2-2.06-.46,1.38-1.82,2.28-3.49,2.28-1.88,0-3.23-1.04-3.23-2.77ZM74.31,264.71c1.6,0,2.85-1.22,2.85-2.97v-.76l-1.92.24c-1.86.22-2.85.72-2.85,1.88s.84,1.62,1.92,1.62Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,255.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,262.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,251.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36ZM95.92,255.85h1.9v9.96h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.56,262.66l1.76-.06c.12,1.36,1.18,2.21,2.63,2.21,1.18,0,2.2-.54,2.2-1.58,0-.78-.6-1.22-1.78-1.46l-1.7-.32c-1.94-.32-2.83-1.36-2.83-2.81,0-1.94,1.62-3.15,3.83-3.15s3.97,1.4,4.07,3.47l-1.7.1c-.08-1.3-1.06-2.21-2.4-2.21-1.12,0-2.02.62-2.02,1.62,0,.74.5,1.2,1.4,1.36l1.7.32c2.1.38,3.23,1.34,3.23,2.91,0,1.92-1.72,3.09-4.01,3.09-2.5,0-4.23-1.36-4.39-3.49Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.01,262.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,251.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36ZM117.24,255.85h1.9v9.96h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.95,260.82c0-3.03,2.16-5.27,5.09-5.27,2.53,0,4.57,1.64,4.73,3.99l-1.86.16c-.16-1.46-1.38-2.51-2.89-2.51-1.84,0-3.17,1.54-3.17,3.63,0,2.35,1.52,3.61,3.17,3.61,1.44,0,2.73-.96,2.91-2.58l1.86.14c-.14,2.44-2.18,4.11-4.75,4.11-2.95,0-5.09-2.22-5.09-5.29Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.32,255.85h1.9v1.68c.74-1.24,1.98-1.94,3.51-1.94,2.67,0,4.61,2.18,4.61,5.25s-1.94,5.23-4.61,5.23c-1.54,0-2.77-.7-3.51-1.94v5.47h-1.9v-13.75ZM141.25,264.51c1.84,0,3.17-1.54,3.17-3.67s-1.34-3.69-3.17-3.69-3.15,1.5-3.15,3.69,1.3,3.67,3.15,3.67Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,255.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,260.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.1,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM159.57,264.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,266.21v-10.36h1.88v10.36c0,3.65-2.73,4.07-4.61,3.43l.04-1.54c.94.36,2.69.52,2.69-1.9ZM167.55,251.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.42,260.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.54-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM178.33,259.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.68,260.82c0-3.03,2.16-5.27,5.09-5.27,2.54,0,4.57,1.64,4.73,3.99l-1.86.16c-.16-1.46-1.38-2.51-2.89-2.51-1.84,0-3.17,1.54-3.17,3.63,0,2.35,1.52,3.61,3.17,3.61,1.44,0,2.73-.96,2.91-2.58l1.86.14c-.14,2.44-2.17,4.11-4.75,4.11-2.95,0-5.09-2.22-5.09-5.29Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.41,262.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,262.66l1.76-.06c.12,1.36,1.18,2.21,2.63,2.21,1.18,0,2.2-.54,2.2-1.58,0-.78-.6-1.22-1.78-1.46l-1.7-.32c-1.94-.32-2.83-1.36-2.83-2.81,0-1.94,1.62-3.15,3.83-3.15s3.97,1.4,4.07,3.47l-1.7.1c-.08-1.3-1.06-2.21-2.4-2.21-1.12,0-2.02.62-2.02,1.62,0,.74.5,1.2,1.4,1.36l1.7.32c2.1.38,3.23,1.34,3.23,2.91,0,1.92-1.72,3.09-4.01,3.09-2.5,0-4.23-1.36-4.39-3.49Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39,255.85h2.04l2.51,7.84,2.4-7.84h2.1l2.42,7.84,2.51-7.84h2l-3.41,9.96h-2.12l-2.44-7.9-2.46,7.9h-2.13l-3.41-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,251.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36ZM230.83,255.85h1.9v9.96h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.16,262.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.39,251.84h1.9v6.23c.46-1.56,1.58-2.47,3.25-2.47,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.33-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-13.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.22,251.84h5.73c2.83,0,4.71,1.56,4.71,3.85,0,2-1.4,3.35-3.41,3.55,1.84.12,2.79,1.12,2.95,2.89l.24,2.29c.04.62.14,1.02.28,1.38h-2c-.1-.3-.2-.72-.26-1.22l-.22-2.29c-.14-1.44-.92-2.16-2.57-2.16h-3.49v5.67h-1.96v-13.97ZM262.84,258.59c1.66,0,2.81-.98,2.81-2.55s-1.16-2.62-2.81-2.62h-3.67v5.17h3.67Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.01,251.84h2.97l4.21,11.96,4.21-11.96h2.97v13.97h-1.94l.12-11.82-4.35,11.82h-2.08l-4.31-11.82.1,11.82h-1.92v-13.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.97,287.26c0-1.86,1.6-2.85,4.61-3.19l2.04-.22v-.4c0-1.46-.82-2.38-2.22-2.38-1.28,0-2.18.82-2.3,2.2l-1.84-.06c.16-2.17,1.84-3.65,4.19-3.65s4.01,1.56,4.01,3.95v3.45c0,1.08.12,2.16.26,2.85h-1.84c-.12-.46-.2-1.02-.2-2.06-.46,1.38-1.82,2.28-3.49,2.28-1.88,0-3.23-1.04-3.23-2.77ZM51.78,288.71c1.6,0,2.85-1.22,2.85-2.97v-.76l-1.92.24c-1.86.22-2.85.72-2.85,1.88s.84,1.62,1.92,1.62Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.59,279.85h1.9l-.06,2.43c.42-1.7,1.56-2.69,3.31-2.69,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.34-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06,284.82c0-3.05,1.94-5.23,4.61-5.23,1.56,0,2.79.72,3.53,1.96v-5.71h1.9v13.97h-1.9v-1.72c-.74,1.26-1.98,1.98-3.53,1.98-2.67,0-4.61-2.18-4.61-5.25ZM74.15,288.51c1.86,0,3.15-1.5,3.15-3.69s-1.3-3.67-3.15-3.67-3.17,1.54-3.17,3.67,1.34,3.69,3.17,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.73,284.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.1,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM89.8,288.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.66,286.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89,275.84h1.9v6.23c.46-1.56,1.58-2.47,3.25-2.47,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.34-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-13.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,284.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.54-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM122.27,283.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.98,279.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.94,279.85h1.9l-.06,2.47c.4-1.72,1.54-2.73,3.31-2.73s2.91.98,3.35,2.61c.42-1.66,1.6-2.61,3.35-2.61,2.14,0,3.49,1.54,3.49,3.99v6.23h-1.9v-5.85c0-1.82-.8-2.83-2.24-2.83-1.62,0-2.53,1.26-2.53,3.53v5.15h-1.88v-5.85c0-1.82-.84-2.83-2.31-2.83-1.68,0-2.59,1.26-2.59,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.02,284.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.53-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM161.92,283.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.63,279.85h1.9l-.06,2.47c.4-1.72,1.54-2.73,3.31-2.73s2.91.98,3.35,2.61c.42-1.66,1.6-2.61,3.35-2.61,2.14,0,3.49,1.54,3.49,3.99v6.23h-1.9v-5.85c0-1.82-.8-2.83-2.24-2.83-1.62,0-2.53,1.26-2.53,3.53v5.15h-1.88v-5.85c0-1.82-.84-2.83-2.32-2.83-1.68,0-2.59,1.26-2.59,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,275.84h1.9v5.69c.74-1.24,1.98-1.94,3.51-1.94,2.67,0,4.61,2.18,4.61,5.25s-1.94,5.23-4.61,5.23c-1.54,0-2.77-.7-3.51-1.94v1.68h-1.9v-13.97ZM188.01,288.51c1.84,0,3.17-1.54,3.17-3.67s-1.34-3.69-3.17-3.69-3.15,1.5-3.15,3.69,1.3,3.67,3.15,3.67Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.55,284.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.54-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM202.46,283.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.17,279.85h1.9l-.06,2.97c.42-2.46,2.14-3.33,3.85-3.01v1.86c-2.1-.28-3.79.96-3.79,3.85v4.29h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.73,286.66l1.76-.06c.12,1.36,1.18,2.21,2.63,2.21,1.18,0,2.2-.54,2.2-1.58,0-.78-.6-1.22-1.78-1.46l-1.7-.32c-1.94-.32-2.83-1.36-2.83-2.81,0-1.94,1.62-3.15,3.83-3.15s3.97,1.4,4.07,3.47l-1.7.1c-.08-1.3-1.06-2.21-2.4-2.21-1.12,0-2.02.62-2.02,1.62,0,.74.5,1.2,1.4,1.36l1.7.32c2.1.38,3.23,1.34,3.23,2.91,0,1.92-1.72,3.09-4.01,3.09-2.5,0-4.23-1.36-4.39-3.49Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,284.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.09,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM231.45,288.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.41,275.72v1.52c-1.1-.34-2.24-.1-2.24,1.48v1.14h2.31v1.58h-2.31v8.38h-1.9v-8.38h-1.86v-1.58h1.86v-1.14c0-2.63,2.22-3.39,4.13-2.99Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,286.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.28,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.34,275.84h1.9v6.23c.46-1.56,1.58-2.47,3.25-2.47,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.33-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-13.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.82,284.82c0-3.07,2.1-5.33,4.99-5.33,3.43,0,5.11,3.09,4.75,5.87h-7.82c.06,1.94,1.34,3.31,3.11,3.31,1.38,0,2.53-.8,2.91-2l1.62.26c-.44,1.84-2.24,3.21-4.55,3.21-2.91,0-5.01-2.24-5.01-5.33ZM274.72,283.94c0-1.7-1.18-3.01-2.91-3.01s-2.89,1.24-3.05,3.01h5.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.07,308.82c0-3.03,2.16-5.27,5.09-5.27,2.53,0,4.57,1.64,4.73,3.99l-1.86.16c-.16-1.46-1.38-2.51-2.89-2.51-1.84,0-3.17,1.54-3.17,3.63,0,2.35,1.52,3.61,3.17,3.61,1.44,0,2.73-.96,2.91-2.58l1.86.14c-.14,2.44-2.18,4.11-4.75,4.11-2.95,0-5.09-2.22-5.09-5.29Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,308.82c0-3.09,2.12-5.27,5.07-5.27s5.05,2.18,5.05,5.27-2.1,5.29-5.05,5.29-5.07-2.2-5.07-5.29ZM64.31,312.51c1.86,0,3.13-1.52,3.13-3.69s-1.28-3.67-3.13-3.67-3.15,1.52-3.15,3.67,1.28,3.69,3.15,3.69Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.18,303.85h1.9l-.06,2.47c.4-1.72,1.54-2.73,3.31-2.73s2.91.98,3.35,2.61c.42-1.66,1.6-2.61,3.35-2.61,2.14,0,3.49,1.54,3.49,3.99v6.23h-1.9v-5.85c0-1.82-.8-2.83-2.24-2.83-1.62,0-2.53,1.26-2.53,3.53v5.15h-1.88v-5.85c0-1.82-.84-2.83-2.31-2.83-1.68,0-2.59,1.26-2.59,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.62,303.85h1.9l-.06,2.47c.4-1.72,1.54-2.73,3.31-2.73s2.91.98,3.35,2.61c.42-1.66,1.6-2.61,3.35-2.61,2.14,0,3.49,1.54,3.49,3.99v6.23h-1.9v-5.85c0-1.82-.8-2.83-2.24-2.83-1.62,0-2.53,1.26-2.53,3.53v5.15h-1.88v-5.85c0-1.82-.84-2.83-2.31-2.83-1.68,0-2.59,1.26-2.59,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.13,312.53c1.64,0,2.55-1.26,2.55-3.53v-5.15h1.9v9.96h-1.9l.06-1.94c-.52,1.4-1.64,2.2-3.25,2.2-2.14,0-3.51-1.54-3.51-4.01v-6.21h1.88v5.85c0,1.82.82,2.83,2.28,2.83Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.76,303.85h1.9l-.06,2.43c.42-1.7,1.56-2.69,3.31-2.69,2.2,0,3.59,1.58,3.59,4.09v6.13h-1.9v-5.85c0-1.82-.84-2.83-2.34-2.83-1.7,0-2.61,1.26-2.61,3.53v5.15h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.55,299.44c.76,0,1.34.6,1.34,1.36s-.58,1.36-1.34,1.36-1.36-.58-1.36-1.36.58-1.36,1.36-1.36ZM127.6,303.85h1.9v9.96h-1.9v-9.96Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,310.74v-5.31h-1.92v-1.58h1.92v-2.5h1.9v2.5h2.57v1.58h-2.57v5.17c0,1.76,1.18,1.94,2.27,1.54l.04,1.58c-1.94.62-4.21.1-4.21-2.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,314.53l.42-1-4.27-9.68h2l3.31,7.58,3.05-7.58h1.92l-4.47,10.68c-1.12,2.71-2.93,3.81-5.25,3.23v-1.6c1.2.32,2.49.08,3.29-1.64Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,312.71c0-.72.56-1.3,1.3-1.3s1.3.58,1.3,1.3-.56,1.3-1.3,1.3-1.3-.56-1.3-1.3Z",
    style: {
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaCard4Mobile);
export default __webpack_public_path__ + "static/media/media-card-4-mobile.3c7356744cb54d4f920e036a583d79ba.svg";
export { ForwardRef as ReactComponent };